import { Record } from 'immutable';
const ImportRequest = Record({
  isRequesting: false,
  error: undefined,
  lastLoaded: null
});
export default ImportRequest;